import { CollaboratorRole } from "@/domain/collaborator/constants"

type CodeLabel = { code?: string | null } | null

type UserCollaborator = {
  status?: CodeLabel
  cluster?: {
    role?: CodeLabel
    status?: CodeLabel
    cluster?: { id: string; name?: string; status?: CodeLabel } | null
  }[]
}

export type ArchiveCluster = { id: string; name: string }

// Roles on a BU that give access to its InterBU archives: any member, not only its managers.
const ARCHIVE_ROLES: (string | null | undefined)[] = [
  CollaboratorRole.COLLABORATOR,
  CollaboratorRole.MANAGER,
]

// Mirror of isRefLabelActive in api/src/Services/MediaDownloadService.php.
const isActive = (status: CodeLabel | undefined) => {
  const code = status?.code ?? ""
  return code === "active" || code.endsWith(":active")
}

// BUs whose InterBU archives the API lists to the user, mirror of assertByClusterDownloadAccess in
// api/src/Services/MediaDownloadService.php: active collaborator, active link as collaborator or
// manager, active BU. Each BU once, in alphabetical order.
export const getArchiveClusters = (collaborators: UserCollaborator[] | undefined) => {
  const clusters = new Map<string, ArchiveCluster>()
  for (const collaborator of collaborators ?? []) {
    if (!isActive(collaborator.status)) continue
    for (const link of collaborator.cluster ?? []) {
      const cluster = link.cluster
      if (!cluster || !isActive(link.status) || !isActive(cluster.status)) continue
      if (!ARCHIVE_ROLES.includes(link.role?.code)) continue
      clusters.set(cluster.id, { id: cluster.id, name: cluster.name ?? "" })
    }
  }
  return [...clusters.values()].sort((a, b) => {
    const [nameA, nameB] = [a.name.toLocaleUpperCase(), b.name.toLocaleUpperCase()]
    return nameA === nameB ? 0 : nameA > nameB ? 1 : -1
  })
}
